import './style.scss'
import { useState, useContext, useEffect, useRef } from "react";
import { RiCloseFill } from "react-icons/ri"
import { AbsoluteContainer, Button, CustomContainer, FlexColumn, SidePopupContainer } from "src/style"
import { ColorPicker as MyPicker, useColor } from "react-color-palette"; 
import "react-color-palette/lib/css/styles.css"; 


export const ColorPicker: React.FC<any> = ({output, close}) => {
    const [color, setColor] = useColor("hex", "#121212"); 
    const isPhoneRef = useRef(false)

    useEffect(() => {
        document.body.style.overflow = 'hidden'

        return () => { document.body.style.overflow = 'auto' }
    }, [])

    useEffect(() => {
        isPhoneRef.current = window.matchMedia('(max-width: 320px)').matches
    }, [])

    function handleColorSelection (color: any) {
        setColor(color)
        output(color.hex)
    }

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="color-palette-container"
                justifyContent="flex-start"
                alignItems="flex-start" 
            >
                <AbsoluteContainer top='0.2' right='0.7'>
                    <Button 
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#000000'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{fontSize: '2rem'}} />
                    </Button> 
                </AbsoluteContainer>
               <CustomContainer>
                    <MyPicker  
                        width={isPhoneRef.current ? 210 : 256} 
                        height={isPhoneRef.current ? 100 : 150} 
                        color={color} 
                        onChange={handleColorSelection} 
                    />
               </CustomContainer>
            </FlexColumn>
        </>
    )
}